<template>
    <card class="spaced typo" v-if="loaded">

        <div class="pt-2" v-if="ctrl.rows.length">

            <h2 class="text-white mb-4">{{ $t('common.accesses') }}</h2>

            <base-table :data="ctrl.rows" :columns="columns">

                <template slot="columns">
                    <th>{{ $t('common.name') }}</th>
                    <th>{{ $t('common.permissions') }}</th>
                    <th>CORS</th>
                    <th></th>
                </template>

                <template slot-scope="{row}">
                    <td :class="cellClass(row)">
                        {{ row.name }}
                    </td>

                    <td v-if="row.admin">
                        <badge type="info" class="mr-1">
                            {{ $t('common.admin') }}
                        </badge>
                    </td>
                    <td v-else>
                        <span v-for="(permission, key) in permissions['xapi-extra'].permissions" :key="key">
                            <badge type="info"
                                class="mr-1"
                                v-if="row.permissions[key] && !row.inherited_permissions">
                                {{ permission.name }}
                            </badge>
                            <badge type="info"
                                class="mr-1"
                                v-if="row.client.permissions[key] && row.inherited_permissions">
                                {{ permission.name }}
                            </badge>
                        </span>
                        <span v-for="(permission, key) in permissions['cmi5'].permissions" :key="key">
                            <badge type="info"
                                class="mr-1"
                                v-if="row.permissions[key] && !row.inherited_permissions">
                                {{ permission.name }}
                            </badge>
                            <badge type="info"
                                class="mr-1"
                                v-if="row.client.permissions[key] && row.inherited_permissions">
                                {{ permission.name }}
                            </badge>
                        </span>
                        <span v-for="(permission, key) in permissions['xapi-scopes'].permissions" :key="key">
                            <badge type="default"
                                class="mr-1"
                                v-if="row.permissions[key] && !row.inherited_permissions">
                                {{ permission.name }}
                            </badge>
                            <badge type="default"
                                class="mr-1"
                                v-if="row.client.permissions[key] && row.inherited_permissions">
                                {{ permission.name }}
                            </badge>
                        </span>
                    </td>

                    <td :class="cellClass(row)">
                        {{ row.cors }}
                    </td>

                    <td class="td-actions text-right">

                        <base-button icon link size="md" type="info" @click="showInfo(row)">
                            <i class="tim-icons icon-c-info"></i>
                        </base-button>

                        <base-button icon link size="md" type="warning" @click="ctrl.update(row.id)">
                            <i class="tim-icons icon-pencil"></i>
                        </base-button>

                        <base-button icon link size="md" type="danger" @click="ctrl.delete(row.id)">
                            <i class="tim-icons icon-simple-remove"></i>
                        </base-button>

                    </td>
                </template>

            </base-table>
        </div>

        <p class="text-center py-3" v-else>{{ $t('accesses.no-access') }}</p>
                
        <div class="text-center">
            <base-button type="primary" @click="ctrl.create()">
                {{ $t('accesses.new') }}
            </base-button>
        </div>

        <portal to="modals">

            <modal class="no-footer" :title="$t('common.access')" v-model="ctrl.modals.edit" :loading="ctrl.form.loading">
                <access-form v-model="ctrl.form.data" :errors="ctrl.form.errors" :permissions="permissions">
                </access-form>
            </modal>

            <modal class="short" :title="infoTitle" size="lg" v-model="ctrl.modals.info">
                <access-info :info="info"></access-info>
            </modal>

            <modal-confirm v-model="ctrl.modals.confirmDelete">
                <p>{{ $t('accesses.delete-confirm') }}</p>
            </modal-confirm>

        </portal>

    </card>
</template>

<script>
    import CrudController from '@trax/classes/CrudController'
    import AccessForm from './AccessForm'
    import AccessInfo from './AccessInfo'

    export default {

        components: {
            AccessForm, AccessInfo
        },

        data() {
            return {
                loaded: false,
                clientId: this.$route.params.id,
                ctrl: new CrudController({
                    endpoint: '/trax/api/front/accesses',
                    mapData: this.mapData,
                    unmapData: this.unmapData,
                    modals: ['info'],
                    query: {
                        sort: ['name'],
                        relations: ['client', 'credentials'],
                        include: ['permissions'],
                        filters: {
                            client_id: this.$route.params.id,
                            visible: true
                        }
                    }
                }),
                columns: ['name', 'permissions'],
                permissions: {},
                info: null
            }
        },

        computed: {

            infoTitle() {
                return this.info ? this.info.name : ''
            }
        },

        created() {
            this.ctrl.init(this, 'ctrl').then(resp => {
                this.loaded = true
                this.permissions = resp.data.included.permissions
            })
        },

        methods: {
            
            mapData(access) {
                return {
                    type: 'basic_http',
                    client_id: this.clientId,
                    id: access ? access.id : null,
                    name: access ? access.name : null,
                    permissions: access && !Array.isArray(access.permissions) ? access.permissions : {},
                    admin: access ? access.admin : false,
                    active: access ? access.active : true,
                    credentials: {
                        username: access ? access.credentials.username : null,
                        password: access ? access.credentials.password : null,
                    },
                    cors: access ? access.cors : null,
                    inherited_permissions: access ? access.inherited_permissions : true,
                    client: access ? access.client : {permissions: {}},
                    endpoint: this.endpoint(access),
                }
            },

            unmapData(data) {
                return data
            },

            cellClass(row) {
                return row.active ? '' : 'disabled'
            },

            endpoint(access) {
                return access 
                    ? this.$baseURL + '/trax/api/' + access.uuid + '/xapi/std'
                    : null
            },

            showInfo(data) {
                this.info = data
                this.ctrl.modals.open('info')
            }
        }
    }
</script>

<style scoped>

    td.disabled {
        color: #777 !important;
    }

</style>
